import { PhoneFilled } from '@ant-design/icons'
import { Space, Tabs } from 'antd'
import API from 'api'
import { Lesson } from 'api/course'
import { getLessonCount } from 'api/utils'
import LessonCard from 'components/CourseOutline/lessonCard'
import { DownloadFileModal } from 'components/DownloadFile'
import React, { useEffect, useState } from 'react'
import './match.less'

const { TabPane } = Tabs

const qr = (
  <div>
    <div className="match-title">五、赛事咨询</div>
    <div className="qr-card">
      <div className="qr-card-left">
        <div>如果您对赛事有任何问题，请与我们联系。</div>
        <div className="qr-phone">
          <PhoneFilled rotate={90} style={{ marginRight: 8 }} />
          199 2523 3153
        </div>
      </div>

      <div
        className="qr-card-right"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/zh-wechat-qr.png)` }}
      ></div>
    </div>
  </div>
)

const MatchPage = () => {
  const [driveCourses, setDriveCourses] = useState<Lesson[]>([])
  const [middleL, setMiddleL] = useState<Lesson[]>([])
  const [middleH, setMiddleH] = useState<Lesson[]>([])
  const rule = level => {
    let src = ''
    switch (level) {
      case 'small':
        src =
          'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/1%20%E5%B0%8F%E5%AD%A6%E7%BB%84-AI%E6%9C%AA%E6%9D%A5%E4%BA%A4%E9%80%9A-%E8%A7%84%E5%88%99%E8%A7%A3%E8%AF%BB.mp4'
        break
      default:
        src =
          'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/2%20%E5%88%9D%E3%80%81%E9%AB%98%E4%B8%AD%E7%BB%84-AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2%E8%A7%86%E9%A2%91-%E8%A7%84%E5%88%99.mp4'
        break
    }

    return (
      // 二、规则解读
      <div>
        <div className="match-title">二、规则解读</div>
        <div className="match-content">
          <div className="match-video-card">
            <video controls className="match-video" controlsList="nodownload" src={src} />
            <div>
              <div>AI未来科学家规则解读</div>
            </div>
          </div>
        </div>
        <div className="match-content">
          <div
            className="match-download"
            onClick={() =>
              downloadFile({
                name: 'AI未来科学家规则解读',
                suffix: 'pptx',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/23-2024%E5%AD%A6%E5%B9%B4AI%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%AE%B6%E8%B5%9B%E9%A1%B9%E8%A7%84%E5%88%99%E8%A7%A3%E8%AF%BB0228V1.0.pptx',
              })
            }
          >
            AI未来科学家规则解读.pptx
          </div>
        </div>
      </div>
    )
  }

  const qa = (
    <div>
      <div className="match-title">六、赛事问答</div>
      <div className="match-content" style={{ flexFlow: 'column' }}>
        <div
          className="match-download"
          style={{ width: 400 }}
          onClick={() =>
            downloadFile({
              name: '2024年NOC大赛《AI未来科学家》赛项问答',
              suffix: 'pdf',
              url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/2024NOC%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%AE%B6%E8%B5%9B%E9%A1%B9%E9%97%AE%E7%AD%94%28%E6%8C%87%E5%AF%BC%E6%95%99%E5%B8%88%E7%94%A8%29.pdf',
            })
          }
        >
          2024年NOC大赛《AI未来科学家》赛项问答.pdf
        </div>
      </div>
    </div>
  )

  const genRenderSort = items => {
    let total = 0
    items.map(l => {
      let c = getLessonCount(l.duration)
      total = total + c
      if (c > 1) {
        l.renderSort = `${total - c + 1}-${total}`
      } else {
        l.renderSort = `${total}`
      }
    })
  }

  useEffect(() => {
    API.listCourse([33], 0).then(res => {
      let items = res.data.items[0]
      genRenderSort(items)
      setDriveCourses(items)
    })
    API.listCourse([35], 0).then(res => {
      let items = res.data.items[0]
      genRenderSort(items)
      setMiddleL(items)
    })
    API.listCourse([60], 0).then(res => {
      let items = res.data.items[0]
      genRenderSort(items)
      setMiddleH(items)
    })
  }, [])

  const [downloadName, setDownloadName] = useState('')
  const [downloadSuffix, setDownloadSuffix] = useState('')
  const [downloadUrl, setDownloadUrl] = useState('')
  const [downloading, setDownloading] = useState(false)

  const downloadFile = ({ name, suffix, url }) => {
    setDownloadName(name)
    setDownloadSuffix(suffix)
    setDownloadUrl(url.substring(52))
    setDownloading(true)
  }

  return (
    <>
      <div
        style={{
          height: 118,
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/match-banner.png)`,
        }}
      ></div>
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 32 }}>
        <Tabs type="card" style={{ width: 1200, backgroundColor: 'white' }}>
          <TabPane tab="小学组" key="1" style={{ padding: '0 30px' }}>
            {/* 安装教程 */}
            <div>
              <div className="match-title">一、器材安装</div>
              <div className="match-content">
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/assemble/AI%E6%9C%AA%E6%9D%A5%E4%BA%A4%E9%80%9A.mp4"
                  />
                  <div>未来交通</div>
                  <div></div>
                </div>
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/assemble/AI%E6%9C%AA%E6%9D%A5%E4%BA%A4%E9%80%9A%E5%AE%89%E8%A3%85%E8%A7%86%E9%A2%91.mp4"
                  />
                  <div>NOC-资源包安装视频</div>
                  <div></div>
                </div>
              </div>
            </div>
            {/* 规则解读 */}
            {rule('small')}
            {/* 演示视频 */}
            <div>
              <div className="match-title">三、演示视频</div>
              <div className="match-content">
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/demo/1%20AI%E6%9C%AA%E6%9D%A5%E4%BA%A4%E9%80%9A%E6%BC%94%E7%A4%BA%E8%A7%86%E9%A2%91-%E5%B0%8F%E5%AD%A6%E7%BB%84.mp4"
                  />
                  <div>
                    <div>未来交通</div>
                  </div>
                </div>
              </div>

              {/* <div className="match-content" style={{ flexFlow: 'column' }}>
                <div
                  className="match-download"
                  style={{ width: 200 }}
                  onClick={() =>
                    downloadFile({
                      name: '未来交通示例程序',
                      suffix: 'xml',
                      url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/demo/AI%E6%9C%AA%E6%9D%A5%E4%BA%A4%E9%80%9A%E8%B5%9B%E4%BA%8B%E7%89%88.xml',
                    })
                  }
                >
                  未来交通示例程序.xml

                </div>
              </div> */}
            </div>
            {/* 赛事课程 */}
            <div>
              <div className="match-title">四、赛事课程</div>
              <div className="match-content">
                {/* 课程列表 */}
                <Space wrap size={[24, 24]} className="course-wall" style={{ marginBottom: 0 }}>
                  {driveCourses.map(course => (
                    <LessonCard
                      key={course.id}
                      lesson={course}
                      total={driveCourses.length}
                      grade_id={24}
                    />
                  ))}
                </Space>
              </div>
            </div>
            {/* 赛事咨询*/}
            {qr}
            {qa}
          </TabPane>
          <TabPane tab="初中组" key="3" style={{ padding: '0 30px' }}>
            {/* 安装教程 */}
            <div>
              <div className="match-title">一、器材安装</div>
              <div className="match-content">
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/assemble/AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2.mp4"
                  />
                  <div>未来医院</div>
                  <div></div>
                </div>
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/assemble/AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2%E5%AE%89%E8%A3%85%E8%A7%86%E9%A2%91.mp4"
                  />
                  <div>NOC-资源包安装视频</div>
                  <div></div>
                </div>
              </div>
            </div>
            {/* 规则解读 */}
            {rule('middle')}
            {/* 演示视频 */}
            <div>
              <div className="match-title">三、演示视频</div>
              <div className="match-content">
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/demo/2%20AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2%E6%BC%94%E7%A4%BA%E8%A7%86%E9%A2%91-%E5%88%9D%E9%AB%98%E4%B8%AD%E7%BB%84.mp4"
                  />
                  <div>
                    <div>未来医院</div>
                  </div>
                </div>
              </div>

              {/* <div className="match-content">
                <div
                  className="match-download"
                  onClick={() =>
                    downloadFile({
                      name: '未来医院示例',
                      suffix: 'sb3',
                      url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/demo/AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2%E8%B5%9B%E4%BA%8B%E7%89%88.sb3',
                    })
                  }
                >
                  未来医院示例.sb3
                </div>
              </div> */}
            </div>
            {/* 赛事课程 */}
            <div>
              <div className="match-title">四、赛事课程</div>
              <div className="match-content">
                {/* 课程列表 */}
                <Space wrap size={[24, 24]} className="course-wall" style={{ marginBottom: 0 }}>
                  {middleL.map(course => (
                    <LessonCard
                      key={course.id}
                      lesson={course}
                      total={middleL.length}
                      grade_id={7}
                    />
                  ))}
                </Space>
              </div>
            </div>
            {/* 赛事咨询 */}

            {qr}
            {qa}
          </TabPane>
          <TabPane tab="高中组" key="4" style={{ padding: '0 30px' }}>
            {/* 安装教程 */}
            <div>
              <div className="match-title">一、器材安装</div>
              <div className="match-content">
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/assemble/AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2.mp4"
                  />
                  <div>未来医院</div>
                  <div></div>
                </div>
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/assemble/AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2%E5%AE%89%E8%A3%85%E8%A7%86%E9%A2%91.mp4"
                  />
                  <div>NOC-资源包安装视频</div>
                  <div></div>
                </div>
              </div>
            </div>
            {/* 规则解读 */}
            {rule('high')}
            {/* 演示视频 */}
            <div>
              <div className="match-title">三、演示视频</div>
              <div className="match-content">
                <div className="match-video-card">
                  <video
                    controls
                    className="match-video"
                    controlsList="nodownload"
                    src="https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/demo/2%20AI%E6%9C%AA%E6%9D%A5%E5%8C%BB%E9%99%A2%E6%BC%94%E7%A4%BA%E8%A7%86%E9%A2%91-%E5%88%9D%E9%AB%98%E4%B8%AD%E7%BB%84.mp4"
                  />
                  <div>
                    <div>未来医院</div>
                  </div>
                </div>

              </div>
              {/* <div className="match-content">
                <div
                  className="match-download"
                  onClick={() =>
                    downloadFile({
                      name: '未来医院示例',
                      suffix: 'py',
                      url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/match/demo/hospital.py',
                    })
                  }
                >
                  未来医院示例.py
                </div>
              </div> */}
            </div>
            {/* 赛事课程 */}
            <div>
              <div className="match-title">四、赛事课程</div>
              <div className="match-content">
                {/* 课程列表 */}
                <Space wrap size={[24, 24]} className="course-wall" style={{ marginBottom: 0 }}>
                  {middleH.map(course => (
                    <LessonCard
                      key={course.id}
                      lesson={course}
                      total={middleH.length}
                      grade_id={59}
                    />
                  ))}
                </Space>
              </div>
            </div>
            {/* 赛事咨询 */}

            {qr}
            {qa}
          </TabPane>
        </Tabs>
      </div>
      <DownloadFileModal
        name={downloadName}
        suffix={downloadSuffix}
        url={downloadUrl}
        downloading={downloading}
        setDownloading={setDownloading}
      />
    </>
  )
}

export default MatchPage
